"use client";

import type { GroupRule } from "@/lib/api/groupRules";

/**
 * "Hvilken regel bryder det?" — the reporter's rule picker (OSO-648), shared
 * by the post ⋮-menu's flag form and the comment's inline one. Renders
 * nothing when the group has no rules, so groups that never wrote any keep
 * the old two-field form.
 */
export function FlagRuleSelect({
  rules,
  value,
  onChange,
  placeholder = "Bryder en regel? (valgfrit)",
  ariaLabel = "Hvilken regel bryder indholdet?",
  className = "w-full rounded border border-border-strong bg-surface text-foreground px-2 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-indigo-500",
}: {
  rules: GroupRule[];
  value: GroupRule["id"] | null;
  onChange: (val: GroupRule["id"] | null) => void;
  placeholder?: string;
  ariaLabel?: string;
  className?: string;
}) {
  if (rules.length === 0) return null;
  return (
    <select
      value={value ?? ""}
      onChange={(e) =>
        onChange(rules.find((r) => String(r.id) === e.target.value)?.id ?? null)
      }
      aria-label={ariaLabel}
      className={className}
    >
      <option value="">{placeholder}</option>
      {rules.map((rule) => (
        <option key={rule.id} value={rule.id}>
          {rule.position}. {rule.title}
        </option>
      ))}
    </select>
  );
}
